import React from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Section1 from "../components/reseller/section1";
import Section2 from "../components/reseller/section2";
import Section3 from "../components/reseller/section3";
import Section4 from "../components/reseller/section4";
import Footer from "../components/navigation/Footer";


const Reseller = () => {
    return (
        <Layout>
            <Section1/>
            <Section2/>
            <Section3/>
            <Section4/>
            <Footer/>
        </Layout>
    );
};


const mapStateToProps = state => ({})

export default connect(mapStateToProps, {})(Reseller)
